import React from "react";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_ai-chatbot-hero-1/artifacts/c5em3lhm_LEUVEN%20%2817%29.png";

export const Logo = ({ size = 32, withWordmark = true, className = "", testId }) => {
  return (
    <div data-testid={testId} className={`flex items-center gap-2.5 ${className}`}>
      <img
          src={LOGO_URL}
          alt="Marlea AI logo"
          width={size}
          height={size}
          className="block object-contain shrink-0"
          style={{ width: size, height: size, mixBlendMode: "screen" }}
        />
      {withWordmark && (
        <span className="font-display font-semibold tracking-tight text-white text-base md:text-lg leading-none">
          Marlea <span className="text-gradient-neon">AI</span>
        </span>
      )}
    </div>
  );
};

export default Logo;
